import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccessibleLinksPipe } from './accessible-links.pipe';

@NgModule({
  declarations: [AccessibleLinksPipe],
  imports: [CommonModule],
  exports: [AccessibleLinksPipe],
})
export class AccessibleLinksModule {}
